var map = {
	"./icons/iksoris-logo-dark.svg": 263,
	"./icons/iksoris-logo-light.svg": 771,
	"./icons/iksoris-logo.svg": 217,
	"./icons/softcom-logo-light.svg": 688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 927;